module.exports = __webpack_public_path__ + "static/media/sketch.b3b9919b.jpg";